/* bnk-brand-suggest.js — releváns MÁRKA-/RENDSZER-KOLLEKCIÓK a predictive search tetején.
 *
 * Ha a látogató egy implantátum-rendszerre vagy gyártóra keres (pl. „nobel”, „semados”,
 * „bonelevel”), a kereső legördülőjének LEGTETEJÉN, kiemelt helyen megjelennek az adott
 * rendszer(ek) kollekció-oldalai — a termék-találatok elé.
 *
 * Adatforrás: window.BNK_BRAND_SYSTEMS (a brand-context-picker.liquid rendereli a
 * fomenu-mega „…rendszerek” oszlopainak leveleiből: {t: cím, u: URL, g: csoport}).
 * A Dawn predictive-search a találatokat innerHTML-lel cseréli → MutationObserverrel
 * figyeljük a konténert, és minden újrarajzolás után beszúrjuk a saját blokkunkat.
 */
(function () {
  if (window.__bnkBrandSuggestInit) return;
  window.__bnkBrandSuggestInit = true;

  var MAX = 6;

  function norm(s) {
    return String(s || '')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function entries() {
    var raw = window.BNK_BRAND_SYSTEMS || [];
    if (!raw.__bnkPrepped) {
      raw.forEach(function (e) {
        if (!e) return;
        e._n = norm(e.t);
        e._toks = e._n.split(' ').filter(Boolean);
      });
      try { Object.defineProperty(raw, '__bnkPrepped', { value: true }); } catch (err) { raw.__bnkPrepped = true; }
    }
    return raw;
  }

  // Általános (nem márka-jelölő) szavak: ezekre önmagukban NEM ajánlunk rendszert,
  // különben az „implantátum csavar” keresés az összes …implantátum nevű rendszert hozná.
  var STOP = {
    implantatum: 1, implantatumok: 1, implant: 1, rendszer: 1, rendszerek: 1,
    mini: 1, short: 1, fej: 1, fejek: 1, csavar: 1, csavarok: 1, standard: 1,
    line: 1, system: 1, plus: 1, tech: 1, direct: 1, vent: 1, screw: 1, ideiglenes: 1
  };

  // Egyezés-pontszám: -1 = nincs egyezés, kisebb szám = erősebb egyezés.
  // A lényeg, hogy a rendszernév akkor is felismerhető legyen, ha a keresésben
  // MÁS SZAVAK is vannak („pitteasy univer”, „minta pitteasy”).
  function score(e, qt, qJoined) {
    var nameJoined = e._n.replace(/ /g, '');

    // 1) A keresés MINDEN szava a névre illeszkedik (a vásárló lényegében a márkát írta).
    var s = 0, all = true;
    for (var i = 0; i < qt.length; i++) {
      var t = qt[i], hit = -1;
      for (var j = 0; j < e._toks.length; j++) {
        if (e._toks[j].indexOf(t) === 0) { hit = j; break; }
      }
      if (hit === -1) {
        // A teljes névben (szóközök nélkül) is elfogadjuk (pl. „bonelevel” ↔ „Bone Level”)
        if (nameJoined.indexOf(t) === -1) { all = false; break; }
        s += 3;
      } else {
        s += hit === 0 ? 0 : 1;
      }
    }
    if (all) return s;

    // Egyéb szavak mellett csak elég egyedi nevet ismerünk fel.
    if (nameJoined.length < 4) return -1;

    // 2) A teljes név egybeírva megjelenik a keresésben: „minta pitteasy”, „pitteasy univer”.
    if (qJoined.indexOf(nameJoined) !== -1) return 10;

    // 3) A név MINDEN szava külön keresőszóként megvan: „bone level fej”.
    var allTok = e._toks.length > 0 && e._toks.every(function (nt) {
      return qt.some(function (t) { return t.length >= 3 && nt.indexOf(t) === 0; });
    });
    if (allTok) return 12;

    // 4) A név egy elég egyedi (nem általános) szava pontosan szerepel: „bioss fej”.
    var strong = e._toks.some(function (nt) {
      return nt.length >= 5 && !STOP[nt] && qt.indexOf(nt) !== -1;
    });
    if (strong) return 14;

    return -1;
  }

  function match(q) {
    var qn = norm(q);
    if (qn.length < 2) return [];
    var qt = qn.split(' ').filter(Boolean);
    var qJoined = qn.replace(/ /g, '');
    var seen = {}, out = [];
    entries().forEach(function (e) {
      if (!e || !e.t || !e.u || seen[e.u + '|' + e.t]) return;
      var sc = score(e, qt, qJoined);
      if (sc < 0) return;
      seen[e.u + '|' + e.t] = 1;
      out.push({ e: e, s: sc });
    });
    out.sort(function (a, b) { return a.s - b.s || a.e.t.length - b.e.t.length; });
    return out.slice(0, MAX).map(function (o) { return o.e; });
  }

  // Egybeírt márkanév szétbontása a kanonikus szavakra: „pitteasy” → ["pitt","easy"].
  // A Shopify a címeket/tageket SZAVANKÉNT indexeli („Pitt-Easy®” → pitt + easy),
  // ezért az egybeírt alak wildcarddal sem találna. A keresőt bővítő szkriptek
  // (predictive-search.js, semantic-search.js) ezt hívják beküldés előtt.
  function brandWords(word) {
    var wn = norm(word);
    if (!wn || wn.indexOf(' ') !== -1) return null;
    var found = null;
    entries().forEach(function (e) {
      if (found || !e || !e._n || e._n.indexOf(' ') === -1) return;
      if (e._n.replace(/ /g, '') === wn) found = e._toks.slice();
    });
    return found;
  }
  window.BnkBrandWords = brandWords;

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function build(hits, variant) {
    var box = document.createElement('div');
    box.className = 'bnk-brandhits' + (variant === 'page' ? ' bnk-brandhits--page bnk-hints__sec' : '');
    box.setAttribute('data-bnk-brandhits', '');
    var html = '<h2 class="predictive-search__heading bnk-brandhits__heading">Rendszerek és márka-oldalak</h2>'
      + '<ul class="bnk-brandhits__list list-unstyled" role="group" aria-label="Rendszerek és márka-oldalak">';
    hits.forEach(function (e, i) {
      html += '<li id="bnk-brandhit-' + i + '" class="bnk-brandhits__item predictive-search__list-item" role="option" aria-selected="false">'
        + '<a class="bnk-brandhits__link" href="' + esc(e.u) + '" tabindex="-1">'
        + '<span class="bnk-brandhits__name">' + esc(e.t) + '</span>'
        + '<span class="bnk-brandhits__meta">' + esc(e.g || 'Rendszer') + '</span>'
        + '<span class="bnk-brandhits__arw" aria-hidden="true">&rarr;</span>'
        + '</a></li>';
    });
    html += '</ul>';
    box.innerHTML = html;
    return box;
  }

  function currentQuery(ps) {
    var input = ps.querySelector('input[name="q"]');
    return input ? input.value.trim() : '';
  }

  function inject(ps) {
    var container = ps.querySelector('[data-predictive-search]');
    if (!container) return;
    var results = container.querySelector('#predictive-search-results');
    if (!results) return;
    var q = currentQuery(ps);
    var old = results.querySelector('[data-bnk-brandhits]');
    var hits = match(q);
    if (!hits.length) { if (old) old.remove(); return; }
    // Idempotens: ha ugyanaz a lista van már kint, ne írjuk újra (nincs observer-ciklus).
    var key = q + '::' + hits.map(function (e) { return e.u + '|' + e.t; }).join(',');
    if (old && old.getAttribute('data-bnk-key') === key) return;
    var box = build(hits);
    box.setAttribute('data-bnk-key', key);
    if (old) old.replaceWith(box);
    else results.insertBefore(box, results.firstChild);
  }

  function watch(ps) {
    if (ps.__bnkWatched) return;
    ps.__bnkWatched = true;
    var container = ps.querySelector('[data-predictive-search]');
    if (!container) return;
    var obs = new MutationObserver(function () { inject(ps); });
    obs.observe(container, { childList: true, subtree: true });
    var input = ps.querySelector('input[name="q"]');
    if (input) input.addEventListener('input', function () { setTimeout(function () { inject(ps); }, 0); });
    inject(ps);
  }

  // ── Közös javaslat-panel a KERESŐ OLDALON ──────────────────────────────────
  // Egyetlen kártyában él a helyesírás-javaslat, a rendszer-/márka-ajánló és a
  // kategória-ajánló (a search-suggest.js ugyanezt a hostot használja — a két
  // szkript sorrendje nem számít, mindkettő létrehozza, ha még nincs).
  function hintsHost() {
    var panel = document.querySelector('[data-bnk-hints]');
    if (panel) return panel;
    var anchor = document.getElementById('ProductGridContainer');
    var wrap = document.createElement('div');
    wrap.className = 'page-width bnk-hints-wrap';
    panel = document.createElement('div');
    panel.className = 'bnk-hints';
    panel.setAttribute('data-bnk-hints', '');
    wrap.appendChild(panel);
    // Függőleges szűrőnél a grid szülője a .facets-vertical flex-sor: a panelt a
    // TELJES szűrő+grid blokk (és a rendezősáv) fölé tesszük, különben középső
    // oszloppá válna, illetve a rendezősáv negatív margója alá csúszna.
    var vwrap = (anchor && anchor.closest) ? anchor.closest('.facets-vertical') : null;
    if (vwrap && vwrap.parentNode) {
      var sortBar = vwrap.parentNode.querySelector('.facets-vertical-sort');
      var ref = (sortBar && sortBar.parentNode === vwrap.parentNode) ? sortBar : vwrap;
      vwrap.parentNode.insertBefore(wrap, ref);
    } else if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(wrap, anchor);
    } else {
      var mc = document.getElementById('MainContent');
      if (!mc) return null;
      mc.insertBefore(wrap, mc.firstChild);
    }
    return panel;
  }

  // Szekció behelyezése a panelbe, rögzített sorrendben (1 = helyesírás,
  // 2 = rendszerek, 3 = kategóriák).
  function putSection(panel, section, order) {
    section.setAttribute('data-bnk-sec', String(order));
    var ref = null;
    for (var i = 0; i < panel.children.length; i++) {
      if (parseInt(panel.children[i].getAttribute('data-bnk-sec') || '9', 10) > order) {
        ref = panel.children[i];
        break;
      }
    }
    panel.insertBefore(section, ref);
  }
  window.BnkSearchHints = { host: hintsHost, put: putSection };

  // A KERESŐ OLDALON (nem csak a legördülőben) is: a keresőszóra releváns
  // rendszer-/márka-kollekciók a találati lista fölött.
  function injectSearchPage() {
    if (!/^\/search(\/|$)/.test(location.pathname)) return;
    var q = '';
    try { q = new URLSearchParams(location.search).get('q') || ''; } catch (e) {}
    // A keresőmezőbe tett `*` wildcardok (predictive-search.js) itt csak zaj.
    q = q.replace(/\*/g, ' ');
    var old = document.querySelector('[data-bnk-brandhits-page]');
    var hits = match(q);
    if (!hits.length) { if (old) old.remove(); return; }
    var key = q + '::' + hits.map(function (e) { return e.u + '|' + e.t; }).join(',');
    if (old && old.getAttribute('data-bnk-key') === key) return;
    var panel = hintsHost();
    if (!panel) return;
    var sec = build(hits, 'page');
    sec.setAttribute('data-bnk-brandhits-page', '');
    sec.setAttribute('data-bnk-key', key);
    if (old) old.replaceWith(sec);
    else putSection(panel, sec, 2);
  }

  function scan() {
    document.querySelectorAll('predictive-search').forEach(watch);
    injectSearchPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan);
  document.addEventListener('bionika:content-swapped', scan);
})();
